console.log("BASE_URL:", import.meta.env.VITE_APP_API_HOST);
console.log("AUTHORITY:", `https://login.microsoftonline.com/${import.meta.env.VITE_APP_AZURE_TENANT_ID}`);
console.log("CLIENT_ID:", import.meta.env.VITE_APP_AZURE_CLIENT_ID);
console.log("TENANT_ID:", import.meta.env.VITE_APP_AZURE_TENANT_ID);
console.log("APP_API_SCOPE:", import.meta.env.VITE_APP_API_SCOPE);
console.log("REDIRECT_URI:", import.meta.env.VITE_APP_AZURE_REDIRECT_URI);
console.log("POST_LOGOUT_REDIRECT_URI:", import.meta.env.VITE_APP_AZURE_POST_LOGOUT_REDIRECT_URI);

export const BASE_URL = import.meta.env.VITE_APP_API_HOST;
export const AUTHORITY = `https://login.microsoftonline.com/${import.meta.env.VITE_APP_AZURE_TENANT_ID}`;
export const CLIENT_ID = import.meta.env.VITE_APP_AZURE_CLIENT_ID;
export const TENANT_ID = import.meta.env.VITE_APP_AZURE_TENANT_ID
export const APP_API_SCOPE = import.meta.env.VITE_APP_API_SCOPE
export const REDIRECT_URI = import.meta.env.VITE_APP_AZURE_REDIRECT_URI
export const POST_LOGOUT_REDIRECT_URI = import.meta.env.VITE_APP_AZURE_POST_LOGOUT_REDIRECT_URI